import React, { useEffect, useCallback } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { addApplicationKey } from '../../state/application'
import { useDispatch } from 'react-redux'

export const GeoLocation = () => {
  const dispatch = useDispatch()
  let allowGeoRecall = true

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, positionError)
    } else {
      console.log('Geolocation is not supported by this device')
    }
  })

  const positionError = () => {
    if (allowGeoRecall) getLocation()
  }

  function showPosition(position) {
    dispatch(
      addApplicationKey('geoLocation', {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
    )
    allowGeoRecall = false
  }

  useEffect(() => {
    getLocation()
  }, [getLocation])

  return (
    <div className="vh-100">
      <div className="token-view  mx-auto col-sm-8 col-md-4">
        <ReactBootstrap.Alert
          style={{ marginTop: '50%' }}
          variant="info"
          className=" text-center p-2"
        >
          <p className={'mt-1'}>We are trying to access your location.</p>

          <p>
            Please enable location access in case its not, to continue further.
          </p>
        </ReactBootstrap.Alert>
      </div>
    </div>
  )
}
